<template>
  <v-sheet class="w-100">
    <v-toolbar>
      <v-toolbar-title>{{ $t('views.userAdmin.editTitle') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon size="x-small" color="rgb(var(--v-theme-background))" @click="$emit('cancel')">
        <v-icon>mdi-close</v-icon>
        <v-tooltip activator="parent" location="start">{{ $t('common.actions.close') }}</v-tooltip>
      </v-btn>
    </v-toolbar>

    <v-form ref="form" class="pt-8">
      <v-row>
        <v-col cols="8" offset="2">
          <v-text-field
            v-model="formUser.email"
            :label="$t('domain.fields.email')"
            variant="outlined"
            disabled
            :rules="rules.email"></v-text-field>
        </v-col>

        <v-col cols="8" offset="2">
          <v-text-field
            v-model="formUser.given_name"
            :label="$t('domain.fields.firstName')"
            variant="outlined"
            :disabled="props.readonly"
            :rules="rules.given_name"></v-text-field>
        </v-col>

        <v-col cols="8" offset="2">
          <v-text-field
            v-model="formUser.family_name"
            :label="$t('domain.fields.lastName')"
            variant="outlined"
            :disabled="props.readonly"
            :rules="rules.family_name"></v-text-field>
        </v-col>

        <v-col cols="8" offset="2">
          <v-select
            v-model="formUser.roles"
            multiple
            :items="availableRoles"
            :label="$t('domain.fields.roles')"
            variant="outlined"
            :readonly="props.readonly"
            item-title="name"
            item-value="id"
            :loading="loadingRoles" />
        </v-col>
      </v-row>
    </v-form>

    <v-container class="pt-0">
      <div class="text-right ma-2">
        <v-btn color="rgb(var(--v-theme-background))" size="small" class="mr-2" variant="flat" @click="emits('cancel')">
          {{ $t('common.actions.cancel') }}
        </v-btn>
        <v-btn color="primary" size="small" variant="flat" @click="save">
          {{ $t('common.actions.save') }}
        </v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>
<script lang="ts" setup>
// Composables
import type { PropType } from 'vue'
import { onMounted, ref } from 'vue'

import { VForm } from 'vuetify/components'

import { getUserRoles, listAvailableUserRoles } from '@/services/api/user.ts'

import useUserManagement from '../../composables/useUserManagement'
import type { Role, User, UserManagementEmits } from '../../types/User'

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    default: () => ({})
  },
  readonly: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits<UserManagementEmits>()
const form = ref<InstanceType<typeof VForm>>()
const availableRoles = ref<Role[]>([])
const loadingRoles = ref(false)

const { rules, formUser, save } = useUserManagement(props.user, emits, form)

onMounted(async () => {
  try {
    loadingRoles.value = true
    availableRoles.value = (await listAvailableUserRoles()) as Role[]
    formUser.value.roles = (await getUserRoles(props.user)) as string[]
  } catch (error) {
    console.error('Error fetching roles:', error)
  } finally {
    loadingRoles.value = false
  }
})
</script>

<style scoped lang="scss">
:deep(.v-window__container) {
  min-height: 50vh;
}

.list-loading {
  &::v-deep(.v-skeleton-loader__button) {
    max-width: 20px;
    height: 20px;
  }
}

.available-roles {
  width: 30em;
  background-color: #3e3e3e;
  //height: 50vh;
}

.user-roles {
  width: 30em;
  background-color: #3e3e3e;
}

.roles-list {
  height: 100%;
  overflow: auto;
  scrollbar-width: thin;
}
</style>
